import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authService } from '../../services/api';
import dividuBlue from '../../assets/dividu-blue.svg';

/**
 * Página de login moderna com design elegante.
 */
const LoginPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    // Limpa erro ao digitar
    if (error) setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await authService.login(formData.email, formData.password);
      
      // Verifica se há token de convite pendente
      const pendingToken = localStorage.getItem('pendingInviteToken');
      if (pendingToken) {
        localStorage.removeItem('pendingInviteToken');
        navigate(`/invite/${pendingToken}`);
      } else {
        navigate('/groups');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Email ou senha incorretos');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-card">
          {/* Logo */}
          <div className="auth-logo">
             <img src={dividuBlue} alt="Dividu" style={{ height: '70px', width: 'auto' }} />
          </div>

          {/* Title */}
          <h1 className="auth-title">Bem-vindo de volta!</h1>
          <p className="auth-subtitle">Entre para gerenciar suas despesas</p>

          {/* Error Alert */}
          {error && (
            <div className="alert alert-error">
              <span>⚠️</span>
              {error}
            </div>
          )}

          {/* Form */}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Email</label>
              <input
                type="email"
                name="email"
                className={`form-input ${error ? 'error' : ''}`}
                value={formData.email}
                onChange={handleChange}
                placeholder="seu@email.com"
                required
                autoComplete="email"
              />
            </div>

            <div className="form-group">
              <label className="form-label">Senha</label>
              <input
                type="password"
                name="password"
                className={`form-input ${error ? 'error' : ''}`}
                value={formData.password}
                onChange={handleChange}
                placeholder="••••••••"
                required
                autoComplete="current-password"
              />
              <div style={{ textAlign: 'right', marginTop: '8px' }}>
                <Link to="/forgot-password" style={{ fontSize: '13px', color: '#6366F1' }}>
                  Esqueceu a senha?
                </Link>
              </div>
            </div>

            <button
              type="submit"
              className="btn btn-primary btn-block btn-lg"
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="loading-spinner" style={{ width: 20, height: 20, borderWidth: 2 }}></span>
                  Entrando...
                </>
              ) : (
                <>
                  Entrar
                  <span>→</span>
                </>
              )}
            </button>
          </form>

          {/* Footer */}
          <div className="auth-footer">
            Não tem uma conta?{' '}
            <Link to="/register">Criar conta grátis</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
